module.exports = __webpack_public_path__ + "img/tourism-badge.13ad4269.png";